export default __webpack_public_path__ + "static/media/chat-w-us.ef894df3.png";